<div class="scroll-picker-wrapper">
  <span class="picker-label">{{
    getTranslatedText('COMMON.' + label) || label
  }}</span>
  <div
    #container
    class="picker-container custom-scrollbar"
    [style.height.px]="height ? height - 30 : null"
  >
    @for (item of items; track item; let i = $index) {
      <button
        #itemBtn
        type="button"
        (click)="onItemClick(item)"
        [class.selected]="item === selected"
        class="picker-button"
        role="option"
        [attr.aria-selected]="item === selected"
        [attr.aria-label]="'Select ' + label + ' ' + item"
      >
        {{ item }}
      </button>
    }
  </div>
</div>
